var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-query"},[_c('query-form',{attrs:{"config":['产品名称', '生产者账号', '串号', '通信编号']},on:{"fetch-data":_vm.fetchData}}),_c('count-total',{attrs:{"total":_vm.total}}),_c('my-list',{attrs:{"btnConfig":['查看二维码', '查看证书', '查看文件', '修改配置', '删除'],"dataSource":_vm.dataSource,"loading":_vm.loading,"flag":_vm.flag,"search":_vm.search}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }